<template>
  <div>
    <v-dialog persistent :value="addModal" width="700">
      <v-card>
        <loading-block class="pt-8" v-if="!loaded"></loading-block>
        <div v-else>
          <v-card-title>
            <v-btn
              fab
              small
              depressed
              class="primary mr-2"
              @click="type = ''"
              v-if="type === 'new'"
            >
              <v-icon>
                fa-arrow-left
              </v-icon>
            </v-btn>
            {{
              'Create a new product ' +
                (form.allergen ? form.allergen : '')
            }}</v-card-title
          >
          <v-card-text>
            <!-- if type is blank show 2 options -->
            <div v-if="type == ''">
              <v-btn
                color="primary"
                class="ma-2 white--text"
                @click.prevent="syncPosPriceAndQty()"
                >SYNC WITH OCS</v-btn
              >
              <v-btn
                color="primary"
                class="ma-2 white--text"
                @click.prevent="type = 'new'"
                >CREATE NEW PRODUCT</v-btn
              >
              <v-btn
                color="primary"
                class="ma-2 white--text"
                @click.prevent="uploadOcs()"
              >UPLOAD OCS</v-btn>
              <input
                ref="uploader"
                class="d-none"
                type="file"
                @change="onFileChanged"
              >
            </div>

            <v-form ref="addForm" v-if="type == 'new'" lazy-validation>
              <v-layout wrap justify-space-between>
                <v-flex
                  xs12
                  sm12
                  md6
                  :class="$vuetify.breakpoint.width > 960 ? 'pr-3' : ''"
                >
                  <v-autocomplete
                    v-model="form.brand_id"
                    :rules="normalValidation"
                    :items="selectableBrands"
                    label="Brand name"
                  ></v-autocomplete>
                  <v-autocomplete
                    v-model="form.category_id"
                    :rules="normalValidation"
                    :items="selectableCategories"
                    label="Category"
                  ></v-autocomplete>
                  <v-text-field
                    v-model="form.name"
                    :rules="textValidation"
                    name="Name"
                    label="Name"
                    required
                    validate-on-blur
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    v-model="form.street_name"
                    name="Street name"
                    label="Street name"
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    v-model="form.description"
                    name="Description"
                    label="Description"
                    required
                    validate-on-blur
                    type="text"
                  ></v-text-field>
                  <v-select
                    v-model="form.product_type"
                    :rules="normalValidation"
                    :items="[
                      {
                        text: 'Variant',
                        value: 'variant'
                      },
                      {
                        text: 'No variant',
                        value: 'no_variant'
                      }
                    ]"
                    name="Product type"
                    label="Product type"
                  ></v-select>

                  <v-select
                    v-model="form.product_family"
                    :rules="normalValidation"
                    :items="[
                      {
                        text: 'Cannabis',
                        value: 'cannabis'
                      },
                      {
                        text: 'Accessories',
                        value: 'accessories'
                      },
                      {
                        text: 'Liquor',
                        value: 'liquor'
                      },
                      {
                        text: 'Retail',
                        value: 'retail'
                      }
                    ]"
                    name="Product family"
                    label="Product family"
                  ></v-select>

                  <v-switch
                    :prepend-icon="'fas fa-heart'"
                    v-model="form.featured"
                    name="Featured"
                    label="Featured"
                    color="primary"
                  ></v-switch>
                </v-flex>

                <v-flex
                  xs12
                  sm12
                  md6
                  :class="$vuetify.breakpoint.width > 960 ? 'pl-3' : ''"
                >
                  <v-textarea
                    v-model="form.usage_instructions"
                    name="Usage instruction"
                    label="Usage instruction"
                  ></v-textarea>
                  <v-select
                    v-model="form.weighing_unit"
                    :rules="normalValidation"
                    :items="[
                      'g',
                      'ml',
                      'kg',
                      'ltr',
                      'caps',
                      'ea',
                      'pack',
                      'oz',
                      'capsule',
                      'bottle',
                      'strips'
                    ]"
                    name="Weighing unit"
                    label="Weighing unit"
                  ></v-select>
                  <v-text-field
                    v-model="form.shelf_life"
                    name="Shelf life"
                    label="Shelf life"
                    type="number"
                    @input="validateShelf"
                  ></v-text-field>

                  <v-select
                    v-model="form.shelf_life_unit"
                    :rules="shelfLifeValidation"
                    :items="[
                      {
                        text: 'Days',
                        value: 'days'
                      },
                      {
                        text: 'Weeks',
                        value: 'weeks'
                      },
                      {
                        text: 'Months',
                        value: 'months'
                      },
                      {
                        text: 'Years',
                        value: 'years'
                      }
                    ]"
                    name="Shelf life unit"
                    label="Shelf life unit"
                  ></v-select>

                  <v-text-field
                    v-model="form.order"
                    name="Order"
                    label="Order"
                    :rules="positiveNumberValidation"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    required
                    validate-on-blur
                    type="number"
                  ></v-text-field>
                  <v-switch
                    v-model="form.discontinued"
                    name="Discontinued"
                    label="Discontinued"
                    color="primary"
                  ></v-switch>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              @click="closeModal()"
              color="white"
              :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
              style="text-transform: capitalize;"
              >Cancel</v-btn
            >
            <v-btn
              v-if="type != ''"
              @click="add()"
              color="white"
              :class="
                $vuetify.breakpoint.width > 960
                  ? 'ml-0 mr-0 primary'
                  : 'ml-0 primary'
              "
              style="text-transform: capitalize;"
              >Create</v-btn
            >
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { BrandAPI } from '@/clients/product/brand.api'
import { CategoryAPI } from '@/clients/product/category.api'
import { ProductAPI } from '@/clients/product/product.api'
import { OCSProductAPI } from '@/clients/product/ocsProduct.api.js'
import { LocationProductAPI } from '@/clients/location/location.product.api'
import LoadingBlock from '@/components/custom-components/LoadingBlock.vue'
import Helper from '@/utility/Helpers'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    LoadingBlock
  },
  data() {
    return {
      loaded: false,
      normalValidation: [v => !!v || 'Field is required'],
      textValidation: [
        v => !!v || 'Field is required',
        v => Helper.validateSpace(v) || `Blank value.`
      ],
      positiveNumberValidation: [
        v => !!v || 'Field is required',
        v => v !== 0 || 'Must be greater than 0.',
        v => /^\+?(0|[1-9]\d*)$/.test(v) || 'Positive numbers only'
      ],
      shelfLifeValidation: [true],
      form: {
        brand_id: '',
        category_id: '',
        name: '',
        // sku: '',
        street_name: '',
        description: '',
        usage_instructions: '',
        discontinued: false,
        product_type: 'variant',
        weighing_unit: '',
        shelf_life: '',
        shelf_life_unit: '',
        order: '',
        featured: false,
        product_family: ''
        // weight: null,
        // price: null,
      },
      brandList: [],
      categoryList: [],
      listItem: [],
      type: '',
      headers: [
        { text: 'Name', value: 'thumbnail', sortable: true, width: 300 },
        { text: 'Category', value: 'category', sortable: true, width: 200 },
        { text: 'Actions', value: 'action', sortable: false, width: 150 }
      ],
      posProductHeading: [
        { text: 'Name', value: 'name', sortable: true, width: 300 },
        { text: 'POS ID', value: 'external_id', sortable: true, width: 100 },
        { text: 'GTIN', value: 'gtin', sortable: true, width: 100 },
        { text: 'Category', value: 'category', sortable: true, width: 200 },
        { text: 'Actions', value: 'action', sortable: false, width: 100 }
      ],
      posProduct: 1,
      posProductCount: 0,
      posProductPerPage: 10,
      locationCategoryList: [],
      selectedFile: null
    }
  },
  computed: {
    selectableBrands: function() {
      return Helper.getSelectableValue(this.brandList, 'name', 'id')
    },
    selectableCategories: function() {
      return Helper.getSelectableValue(this.categoryList, 'name', 'id')
    },
    ...mapGetters({
      vg_activeBusiness: 'auth/activeBusiness',
      addModal: 'product/addPop',
      selectedLocation: 'location/selected'
    })
  },

  watch: {
    type: function(str) {
      // If str is balnk clear form
      if (str === '') {
        Helper.setObjValueEmpty(this.form)
      }
    }
  },
  async created() {
    this.loaded = false
    // We need to fetch Brands because we need to sue here
    // Brand
    // Category

    // brand list
    const brandData = await BrandAPI.brandList()
    // eslint-disable-next-line no-undef
    this.brandList = _.sortBy(brandData.data.payload, 'name')
    // category list
    const CategoryData = await CategoryAPI.list()
    // eslint-disable-next-line no-undef
    this.categoryList = _.sortBy(CategoryData.data.payload, 'name')

    this.loaded = true
  },
  methods: {
    validateShelf() {
      if (this.form.shelf_life) {
        this.shelfLifeValidation = [v => !!v || 'Field is required']
      } else {
        this.shelfLifeValidation = [true]
      }
    },
    /**
     * Back to select option
     */
    backToAddOption() {
      this.clone_from_posProduct = false
      this.type = ''
    },
    /**
     * Sync pos and qty
     */

    async syncPosPriceAndQty() {
      try {
        this.spinner(true)
        let res = await OCSProductAPI.ocsProductImport(this.vg_activeBusiness.id)
        this.spinner(false)
        if (res.status === 200) {
          LocationProductAPI.fetch(this.selectedLocation.id)
        }
        this.snackbar({
          text:
            res.status === 200
              ? res.data.message
              : res.response.data.errors
              ? res.response.data.errors[0]
              : res.response.data.msg,
          color: res.status === 200 ? 'success' : 'error'
        })
      } catch (err) {
        this.spinner(false)
        this.snackbar({
          text: err.response.data.message,
          open: true,
          color: 'error'
        })
      }
    },

    /**
     * Add new product
     */
    async add() {
      if (!this.$refs['addForm'].validate()) return
      try {
        // Hit apis
        this.spinner(true)
        let res = await ProductAPI.insert(this.form)
        this.spinner(false)
        if (res.status === 200) {
          this.$refs['addForm'].reset()
          this.closeModal()
        }
        // Display message alert
        this.snackbar({
          text:
            res.status === 200
              ? res.data.msg
              : res.response.data.errors
              ? res.response.data.errors[0]
              : res.response.data.msg,
          open: true,
          color: res.status === 200 ? 'success' : 'error'
        })
      } catch (err) {
        this.spinner(false)
        this.snackbar({
          text: Array.isArray(err.response.data.errors)
            ? err.response.data.errors[0]
            : err.response.data.message,
          open: true,
          color: 'error'
        })
      }
    },

    uploadOcs() {
      this.$refs.uploader.click()
    },

    async onFileChanged(e) {
      this.selectedFile = e.target.files[0]
      try {
        this.spinner(true)
        let res = await OCSProductAPI.uploadOcs(this.selectedFile)
        this.spinner(false)
        this.snackbar({
          text:
            res.status === 200
              ? (res.data.message || res.data.msg || res.data.payload)
              : res.response.data.errors
              ? res.response.data.errors[0]
              : (res.response.data.msg || res.response.data.payload),
          color: res.status === 200 ? 'success' : 'error'
        })
      } catch (err) {
        this.spinner(false)
        this.snackbar({
          text: err.response.data.msg,
          open: true,
          color: 'error'
        })
      }
    },

    /**
     * Close add  popup
     */
    async closeModal() {
      this.type = ''
      this.setAddPopup(false)
      await Helper.setObjValueEmpty(this.form)
      this.form.discontinued = false
      this.form.featured = false
    },
    ...mapActions({
      setAddPopup: 'product/setAddPop'
    })
  }
}
</script>
